export default {
  properties: {
    default: { type: 'boolean' },
    prefix: { type: 'string' },
    suffix: { type: 'string' },
  },
};
